import { combineReducers } from 'redux';

import { loadingReducer, errorReducer, successReducer } from './status';
import academyReducer from './academy';
import attendanceReducer from './attendance';
import authReducer from './auth';
import branchReducer from './branch';
import busStopReducer from './bus-stop';
import categoryReducer from './category';
import classReducer from './class';
import dashboardReducer from './dashboard';
import eConnectReducer from './e-connect';
import eventReducer from './event';
import expenseReducer from './expense';
import inventoryReducer from './inventory';
import managerReducer from './manager';
import merchantReducer from './merchant';
import orderReducer from './order';
import playerReducer from './player';
import practiceReducer from './practice';
import productReducer from './product';
import redeemReducer from './redeem';
import reportReducer from './report';
import rewardReducer from './reward';
import scheduleReducer from './schedule';
import settingReducer from './setting';
import supplierReducer from './supplier';
import tagReducer from './tag';
import timeOffReducer from './time-off';
import transactionReducer from './transaction';
import uiReducer from './ui';
import uploadReducer from './upload';
import userReducer from './user';

const rootReducer = combineReducers({
  loadingReducer,
  errorReducer,
  successReducer,
  academyReducer,
  attendanceReducer,
  authReducer,
  branchReducer,
  busStopReducer,
  categoryReducer,
  classReducer,
  dashboardReducer,
  eConnectReducer,
  eventReducer,
  expenseReducer,
  inventoryReducer,
  managerReducer,
  merchantReducer,
  orderReducer,
  playerReducer,
  practiceReducer,
  productReducer,
  redeemReducer,
  reportReducer,
  rewardReducer,
  scheduleReducer,
  settingReducer,
  supplierReducer,
  tagReducer,
  timeOffReducer,
  transactionReducer,
  uiReducer,
  uploadReducer,
  userReducer,
});

export default rootReducer;

export type TRootState = ReturnType<typeof rootReducer>;
